import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

const routerList = [
	{
	    path: '/404',
	    component: () => import( '../../pages/404.vue'),
	    name:'nodata404',
	    meta: {title: '抱歉您找的页面失踪了'},
	},
	{
	    path: '/',
	    component: () => import( '../../pages/List.vue'),
	    name:'index',
	    meta: {title: '管理列表'},
	},
	{
	    path: '/login',
	    component: () => import( '../../pages/Login.vue'),
	    name:'login',
	    meta: {title: '登录'},
	}
];
const routerObj = new VueRouter({
    routes:routerList
});

routerObj.beforeEach((to, from, next) => {
     if(to.name == null){
        next({
            path:'/404'
        });
     }else{
       document.title =  to.meta.title + ' - 管理后台'
       next();
     }
})

export default routerObj;